module.exports = __webpack_public_path__ + "img/Meletie_Smotritki_1697_p_1.55822f6a.jpg";